import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { COINS_SVC_INIT_LOADING, COINS_SVC_INIT_SUCCESS, COINS_SVC_INIT_FAIL,
  COINS_SVC_SAVE_LOADING, COINS_SVC_SAVE_SUCCESS, COINS_SVC_SAVE_FAIL } from '@/store/types'

export const coinsSvcFee = {
  async coinsSvcFeeInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyCoinsSvcFee
    commit(COINS_SVC_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(COINS_SVC_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(COINS_SVC_INIT_FAIL, extractMessages(error))
    }
  },
  async createCoinsSvcFee ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.coinsSvcFeeSettings.menu.createCoinsSvcFee
    if (apiUrl) {
      commit(COINS_SVC_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(COINS_SVC_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(COINS_SVC_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(COINS_SVC_SAVE_FAIL, generateManualSaveError(['Fail to save CoinsSvcFee Details']))
        }
        return false
      }
    }
  },
  async updateCoinsSvcFee ({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.coinsSvcFeeSettings.menu.updateCoinsSvcFee
    if (apiUrl) {
      commit(COINS_SVC_SAVE_LOADING)
      try {
        const result = await http.put(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(COINS_SVC_SAVE_SUCCESS, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(COINS_SVC_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(COINS_SVC_SAVE_FAIL, generateManualSaveError(['Fail to save CoinsSvcFee Details']))
        }
        return false
      }
    }
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}
